import { findIndex, forEach, get } from "lodash"
import { createSelector } from "reselect"
import { classificationsMap } from "helpers/classification"
import { computeSort } from "helpers/securities-search"
import { getMissingDataFiles } from "selectors/missingDataFiles"
import { getIsOpPro } from "modules/account-root/selectors"

const EMPTY_ARRAY = []
const EMPTY_OBJECT = {}
export const getWatchlistSecurities = state => get(state, "global.data.watchlistSecurities.data.model.securitySearch.securities", EMPTY_ARRAY)
export const getWatchlistSecuritiesCount = state => get(state, "global.data.watchlistSecurities.data.model.securitySearch.count", null)
export const getWatchlistTotalSecurities = state => get(state, "global.data.watchlist.data.watchlist.count", null)
export const getPage = state => get(state, "modules.watchlist.page", null)
export const getSelectedSecurities = state => get(state, "modules.watchlist.selectedSecurities", EMPTY_OBJECT)
export const getWatchlistMeta = (state, props) => get(props, "watchlist", EMPTY_OBJECT)
export const getFiltersVisible = state => get(state, "modules.watchlist.filtersVisible", false)
export const getEditingFilter = state => get(state, "modules.watchlist.editingFilter", false)
export const getFilterRaw = state => get(state, "modules.watchlist.filter", null)
export const getWatchlistsMenuVisible = state => get(state, "modules.watchlist.watchlistsMenuVisible", false)
export const getColumnSelectorOpen = state => get(state, "modules.watchlist.columnSelectorOpen")
export const getColumnSearches = state => get(state, "modules.watchlist.columnSearches")
const getWatchlistId = (state, props) => get(props, "watchlist.id")
const getClassifications = (state) => get(state, "global.data.classifications.data.classifications")
const getRawSort = (state) => get(state, "modules.watchlist.sort")

export const getSelectedDate = (_, props) => get(props, "selectedDate")
export const getModelId = (_, props) => get(props, "modelId")
export const getCurrency = (_, props) => get(props, "currency")

export const getSort = createSelector(
  [getRawSort, getMissingDataFiles, getModelId, getIsOpPro],
  computeSort,
)

export const getClassificationsTiers = createSelector(
  [getClassifications, getSelectedDate],
  classificationsMap,
)

export const getFilter = createSelector(
  [getFilterRaw, getWatchlistId],
  (filter, watchlistId) => {
    if (filter) {
      return {
        universe: [{
          type: "WATCHLIST",
          in: watchlistId,
        }],
        ...filter,
      }
    } else {
      return {
        universe: [{
          type: "WATCHLIST",
          in: watchlistId,
        }],
      }
    }
  },
)

export const getFilterId = createSelector(
  [getFilter],
  filter => JSON.stringify(filter),
)

export const getWatchlist = createSelector(
  [getWatchlistSecurities, getWatchlistSecuritiesCount, getWatchlistMeta],
  (watchlistSecurities, count, watchlist) => {
    return {
      name: watchlist.name,
      id: watchlist.id,
      alias: watchlist.alias,
      count,
      securities: watchlistSecurities,
    }
  },
)

export const getCurrentPageSelectionStatus = createSelector(
  [getSelectedSecurities, getWatchlistSecurities],
  (selectedSecurities, securities) => {
    if (selectedSecurities.total > 0 && securities) {
      let inPage = 0

      forEach(selectedSecurities.securities, (security, key) => {
        if (findIndex(securities, { id: key }) >= 0) {
          inPage += 1
        }
      })

      if (inPage === securities.length) {
        return "all"
      } else if (inPage > 0) {
        return "intermediate"
      }
    }

    return null
  },
)

export const getToolbarActive = createSelector(
  [getSelectedSecurities],
  (selectedSecurities) =>
    selectedSecurities.total > 0,
)
